import { render, staticRenderFns } from "./SelectTemplate.vue?vue&type=template&id=531fcab8"
import script from "./SelectTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectTemplate.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports